import ReplayCommunication from '~/pages/communication/replay/libs/components/ReplayCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const ReplayCommunicationPage = (props: TPageProps) => (
  <ReplayCommunication {...props} />
)

export default ReplayCommunicationPage
